// LazyLoadSelect.tsx
import React, { Suspense } from 'react';

const LazySelect = React.lazy(() => import('react-dropdown-select'));

// Wrap in a Suspense boundary
export function LazySelectWrapper(props) {
  return (
    <Suspense fallback={<div>…</div>}>
      <LazySelect {...props} />
    </Suspense>
  );
}